import {
    ApiKey,
    _WEB_VERSION,
    _APP_CLIENT_ID,
    _APP_CLIENT_SECRET,
    _MEMBER_ROLE,
    _LOGIN_METHOD,
    SessionKey,
    _OTP_LENGTH
} from '../../common/constant';
import Routes from '../../common/api_routes';
import { showCustomDialog, setBonusDialogData, clearBonusDialogData } from './app_action';
import { Text, Image } from '@chakra-ui/react';
import ApiEngine from '../../common/api_engine';
import i18n from '../../localization/i18n';
import { ConfigEnum } from '../../common/config';
import {
    createFormBody,
    isObjectEmpty,
    stringIsNullOrEmpty,
    numberWithCurrencyFormat
} from '../../common/util';
import axios from 'axios';
import { AuthActionTypes } from '../reducer/auth_reducer';
import { v1 as uuidv1 } from 'uuid';

/// <summary>
/// Author : Juin
/// </summary>
export function performLogin(
    phone,
    password,
    secondaryPassword = '',
    rememberMe = false
) {
    return async (dispatch, getState) => {
        let _device_id = localStorage.getItem(ConfigEnum._DEVICE_ID);

        if (stringIsNullOrEmpty(_device_id)) {
            _device_id = uuidv1();
            localStorage.setItem(ConfigEnum._DEVICE_ID, _device_id);
        }

        let params = {
            client_id: _APP_CLIENT_ID,
            client_secret: _APP_CLIENT_SECRET,
            grant_type: 'password',
            username: phone,
            password: password,
            IsEmulator: false,
            VersionCode: _WEB_VERSION,
            deviceId: _device_id,
        };

        if (!stringIsNullOrEmpty(secondaryPassword)) {
            params['IsValidateSecondary'] = true;
            params['SecondaryPassword'] = secondaryPassword;
        }

        let formBody = createFormBody(params);

        var responseJson = await ApiEngine.post(Routes._LOGIN_URL, formBody, {
            headers: { 'User-Agent': navigator.userAgent.toLowerCase() }
        });

        if (responseJson && responseJson['role'] == _MEMBER_ROLE) {
            if (
                responseJson['secondary_password_method'] == undefined ||
                (responseJson['secondary_password_method'] ==
                    _LOGIN_METHOD._VERIFIED &&
                    !stringIsNullOrEmpty(responseJson.access_token))
            ) {
                await localStorage.setItem(ConfigEnum._USER_DATA, JSON.stringify(responseJson));
                await localStorage.setItem(ConfigEnum._BEARER_TOKEN, responseJson.access_token);

                // responseJson['welcome_bonus'] = { "amount": 100, "banner": "https://www.epay4game.com/Assets/bonus/1711950052816.png", "id": 1, "maxThreshold": 1000, "minThreshold": 1, "name": "Welcome Bonus" }

                if (responseJson['welcome_bonus']) {
                    let bonusData = responseJson['welcome_bonus'];
                    dispatch(setBonusDialogData({
                        hideTitle: true,
                        content: `${i18n.t('GREAT_NEWS')}!`,
                        isManualHideAlert: true,
                        customContent: (
                            <>
                                {
                                    !stringIsNullOrEmpty(bonusData?.banner) &&
                                    <Image
                                        src={bonusData?.banner}
                                        w={'100%'}
                                        h={'50%'}
                                        mb={5}
                                    />
                                }
                                <Text>{i18n.t('GREAT_NEWS_YOU_ENTITLED_BONUS', { bonus: bonusData.name.toUpperCase() })}
                                    <Text fontSize={'lg'} color={'#08CD34'} fontWeight={'bold'} display={'inline-block'}>{`RM ${bonusData.amount}.`}</Text>
                                </Text>
                                <Text fontStyle={'italic'}>{i18n.t('WELCOME_BONUS_REQUIRED_CERTAIN_TURNOVER_TO_UNLOCK_1', { bonus: bonusData.name.toUpperCase() })}
                                    <Text fontSize={'lg'} fontWeight={'bold'} color={'#08CD34'} display={'inline-block'}>{numberWithCurrencyFormat(bonusData.minThreshold)}</Text>
                                    <Text display={'inline-block'}>{" " + i18n.t('WELCOME_BONUS_REQUIRED_CERTAIN_TURNOVER_TO_UNLOCK_2')}</Text>
                                    <Text fontSize={'lg'} fontWeight={'bold'} fontStyle={'italic'} color={'#08CD34'} display={'inline-block'}>{numberWithCurrencyFormat(bonusData.maxThreshold)}</Text>
                                    <Text display={'inline-block'}>{i18n.t('WELCOME_BONUS_REQUIRED_CERTAIN_TURNOVER_TO_UNLOCK_3')}</Text>
                                </Text>
                                <Text>{i18n.t('YOU_WILL_HAVE_TO_CLAIM_THIS_THRU_REWARD_CONVERT', { bonus: bonusData.name.toUpperCase() })}</Text>
                            </>
                        ),
                        horizontalBtn: false,
                        buttonReverseColor: true,
                        cancelTxt: i18n.t('NO_THANKS'),
                        onCancel: () => {
                            dispatch(showCustomDialog({
                                title: i18n.t('ARE_YOU_SURE'),
                                content: i18n.t("ARE_YOU_SURE_YOU_WANT_GIVE_UP_BONUS", { bonus: bonusData.name.toUpperCase(), amount: bonusData.amount }),
                                horizontalBtn: false,
                                onConfirm: () => {
                                    dispatch(clearBonusDialogData());
                                },
                                onCancel: () => { }
                            }));
                        },
                        confirmTxt: i18n.t('YES_I_WANT'),
                        onConfirm: async () => {
                            var claimResponse = await ApiEngine.post(Routes._CLAIM_WELCOME_BONUS);

                            dispatch(showCustomDialog({
                                success: claimResponse[ApiKey._API_SUCCESS_KEY],
                                content: claimResponse[ApiKey._API_MESSAGE_KEY],
                                onConfirm: () => {
                                    if (claimResponse[ApiKey._API_SUCCESS_KEY]) {
                                        dispatch(getMemberDetails());
                                    }

                                    dispatch(clearBonusDialogData());
                                }
                            }));
                        }
                    }));
                }

                if (password.length == _OTP_LENGTH || secondaryPassword.length == _OTP_LENGTH) {
                    await localStorage.setItem(ConfigEnum._REQUIRED_CHANGE_PASSWORD, 'true');
                }

                let savedCredentials = await localStorage.getItem(ConfigEnum._SAVED_CREDENTIALS);
                savedCredentials = (savedCredentials || '').split('|').filter(item => item && !item.startsWith(phone));

                if (rememberMe && password.length != _OTP_LENGTH) {
                    let newSaveCredentials = [`${phone}@${password}`, ...savedCredentials].join('|');
                    await localStorage.setItem(ConfigEnum._SAVED_CREDENTIALS, newSaveCredentials);
                }
                else if (!rememberMe) {
                    let newSaveCredentials = [...savedCredentials].join('|');
                    await localStorage.setItem(ConfigEnum._SAVED_CREDENTIALS, newSaveCredentials);
                }
                
                dispatch({
                    type: AuthActionTypes._LOGIN_SUCCESS,
                    userData: responseJson
                });
            } else {
                return {
                    ...params,
                    method: responseJson['secondary_password_method'],
                    guid: responseJson.guid,
                    whatsappLinks: responseJson['whatsappLinks'],
                    rememberMe: rememberMe
                };
            }
        } else {
            let errorMsg =
                responseJson[ApiKey._API_MESSAGE_KEY] ??
                responseJson[ApiKey._API_ERROR_KEY] ??
                'INVALID_USERNAME_OR_PASSWORD';

            dispatch({
                type: AuthActionTypes._LOGIN_FAILED,
                message: i18n.t(errorMsg)
            });

            dispatch(
                showCustomDialog({
                    success: responseJson[ApiKey._API_SUCCESS_KEY],
                    content: i18n.t(errorMsg)
                })
            );
        }
    };
}

/// <summary>
/// Author : Juin
/// </summary>
export const performLogout = () => {
    return async (dispatch, getState) => {
        let userData = getState().authState.userData;

        if (!isObjectEmpty(userData) && userData.guid) {
            try {
                let bearerToken = localStorage.getItem(ConfigEnum._BEARER_TOKEN)
                let params = {
                    Id: userData.guid
                };

                let formBody = createFormBody(params);
                await axios.post(Routes._LOGOUT_URL, formBody, {
                    headers: {
                        skipLoading: true,
                        'content-type': ApiKey._API_FORM_URLENCODED,
                        Authorization: 'Bearer ' + bearerToken
                    }
                });
            } catch (err) {
                // do nothing
            }
            finally {
                // window.location.replace(Pages._DEFAULT);
            }
        }

        localStorage.removeItem(ConfigEnum._BEARER_TOKEN);
        localStorage.removeItem(ConfigEnum._USER_DATA);
        localStorage.removeItem(ConfigEnum._EVENT_RANKING);
        localStorage.removeItem(ConfigEnum._USER_EVENT_RANKING);
        localStorage.removeItem(ConfigEnum._ADS_ID);
        localStorage.removeItem(ConfigEnum._HOME_BANNER_LAST_RETRIEVED);
        localStorage.removeItem(ConfigEnum._LAST_CHECK_BONUS_DATETIME);
        localStorage.removeItem(ConfigEnum._LAST_CHECK_IN_ANGPOW_DATAILS);
        localStorage.removeItem(ConfigEnum._REQUIRED_CHANGE_PASSWORD);
        sessionStorage.removeItem(SessionKey._BOTTOM_MENU_ITEM);

        await dispatch({
            type: AuthActionTypes._LOGOUT
        });
    };
};

/// <summary>
/// Author : Juin
/// </summary>
export function getMemberDetails(skipLoading = true) {
    return async (dispatch, getState) => {
        let guid = getState().authState.userData.guid;

        if (stringIsNullOrEmpty(guid)) {
            return;
        }

        var responseJson = await ApiEngine.get(
            Routes._MEMBER_DETAILS
                .replace('{id}', guid)
                .replace('{androidVersion}', _WEB_VERSION),
            { headers: { skipLoading } }
        );
        if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
            let errorMsg =
                responseJson[ApiKey._API_MESSAGE_KEY] ??
                responseJson[ApiKey._API_ERROR_KEY] ??
                'INTERNAL_SERVER_ERROR';

            dispatch(
                showCustomDialog({
                    success: responseJson[ApiKey._API_SUCCESS_KEY],
                    content: errorMsg
                })
            );
        } else {
            dispatch({
                type: AuthActionTypes._MEMBER_DETAILS_SUCCESS,
                userData: responseJson[ApiKey._API_DATA_KEY]
            });
        }
    };
}

/// <summary>
/// Author: Juin
/// </summary>
export function performEditProfile(data, successCallback) {
    return async (dispatch, getState) => {
        let errorMsg = '';
        let memberId = getState().authState.userData.guid;

        let formData = new FormData();

        formData.append('alias', data.alias);
        formData.append('phoneNumber', getState().authState.userData.username);

        if (data.profileImage !== undefined) {
            formData.append('profileImage', data.profileImage);
        }

        var responseJson = await ApiEngine.put(
            Routes._EDIT_MEMBER.replace('{id}', memberId),
            formData,
            { 'Content-Type': 'multipart/form-data' }
        );

        if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
            errorMsg =
                responseJson[ApiKey._API_MESSAGE_KEY] ??
                responseJson[ApiKey._API_ERROR_KEY] ??
                'INTERNAL_SERVER_ERROR';
        }

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            dispatch(getMemberDetails());
        }

        dispatch(
            showCustomDialog({
                success: responseJson[ApiKey._API_SUCCESS_KEY],
                content: !responseJson[ApiKey._API_SUCCESS_KEY]
                    ? errorMsg
                    : 'EDIT_PROFILE_SUCCESS',
                onConfirm: () => {
                    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                        successCallback();
                    }
                },
                horizontalBtn: true
            })
        );
    };
}

/// <summary>
/// Author: Juin
/// </summary>
export const updateUserData = (userData) => {
    return async (dispatch) => {
        await dispatch({
            type: AuthActionTypes._LOGIN_SUCCESS,
            userData: userData
        });
    };
};
